import { render, staticRenderFns } from "./Thank.vue?vue&type=template&id=0796fe83&scoped=true&"
import script from "./Thank.vue?vue&type=script&lang=js&"
export * from "./Thank.vue?vue&type=script&lang=js&"
import style0 from "./Thank.vue?vue&type=style&index=0&id=0796fe83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796fe83",
  null
  
)

export default component.exports